import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/case-studies/energy-utilities/page.tsx");
